import React from 'react';

var Plus = function Plus(props) {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13 13",
    style: props.style
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-plus",
    d: "M11.5,5.5h-4v-4c0-0.6-0.4-1-1-1s-1,0.4-1,1v4h-4c-0.6,0-1,0.4-1,1s0.4,1,1,1h4v4c0,0.6,0.4,1,1,1s1-0.4,1-1v-4 h4c0.6,0,1-0.4,1-1S12.1,5.5,11.5,5.5z"
  }));
};

export default Plus;